import $axios from './axios'
import { bizURL, courseURL } from './baseUrl'

function getToken() {
   var getTokenId = sessionStorage.getItem("token");
   return getTokenId;
}

const portData = {

    getUserTime(params) {  // 获取当前用户学习时长
        return $axios({
            url: `${courseURL}/home/getMustAndStartingCourse?tokenId=${getToken()}`,
            method: "get",
            params: params
        });
    },
    getUserInfo(params) {  // 获取当前用户信息
        return $axios({
            url: `${bizURL}/employee/getEmployeeInformation?tokenId=${getToken()}`,
            method: "get",
            params: params
        });
    },
    getCourseList(params) {  // 课程列表
        return $axios({
            url: `${courseURL}/myCourse/getCourseList?tokenId=${getToken()}`,
            method: "get",
            params: params
        });
    },
    getCourseDetail(params) {  // 课程详情
        return $axios({
            url: `${courseURL}/myCourse/getCourseDetails?tokenId=${getToken()}`,
            method: "get",
            params: params
        });
    },
    getVideoConfig(params) {  // 获取视频配置信息
        return $axios({
            url: `${courseURL}/videoPlay/getCourseConfig?tokenId=${getToken()}`,
            method: "get",
            params: params
        });
    },
    getVideoId(params) {  // 获取视频ID及最后播放时间点
        return $axios({
            url: `${courseURL}/videoPlay/getVideoId?tokenId=${getToken()}`,
            method: "get",
            params: params
        });
    },
    /* getStudyList(params) {  // 获取课程详情 学习列表
        return $axios({
            url: `${courseListURL}/exercise/courseExerciseList`,
            method: "get",
            params: params
        });
    } */
    getNextTask(params) {  // 课程详情 下一个学习任务
        return $axios({
            url: `${courseURL}/home/getTheNextStudyCourse?tokenId=${getToken()}`,
            method: "get",
            params: params
        });
    },
    getOfflineList(params) {  // 线下课程列表
        return $axios({
            url: `${courseURL}/enterprise/underline/getUnderlineCourseListFromEnterprise?tokenId=${getToken()}`,
            method: "get",
            params: params
        });
    },
    getOfflineDetail(params) {  // 线下课程列表详情
        return $axios({
            url: `${courseURL}/enterprise/underline/getUnderlineCourseDetail?tokenId=${getToken()}`,
            method: "get",
            params: params
        });
    },
    getOfflineApply(params) {  // 线下课程 提交报名
        return $axios({
            url: `${courseURL}/enterprise/underline/saveUnderlineRegisterCourse?tokenId=${getToken()}`,
            method: "post",
            data: params
        });
    },
    getExerciseList(params) {  // 在线练习   我的练习
        return $axios({
            url: `${courseURL}/exercise/exerciseList`,
            method: "get",
            params: params
        });
    },
    getUpload(params) {  // 个人中心  上传文件到本地
        return $axios({
            url: `${courseURL}/file/uploadFile`,
            method: "get",
            params: params
        });
    },
    getSpecial(params) {  // 获取注册专业
        return $axios({
            url: `${bizURL}/post/getPostList`,
            method: "get",
            params: params
        });
    },
    trainRecord(params) {  //  培训记录
        return $axios({
            url: `${courseURL}/trainingRecord/getMyTrainingRecord?tokenId=${getToken()}`,
            method: "get",
            params: params
        });
    },
    // getPhoto(params) {  // 查看学习照片
    //     return $axios({
    //         url: `${courseURL}/course/getEmployeeStudyPhotoList?tokenId=${getToken()}`,
    //         method: "get",
    //         params: params
    //     });
    // },
    employeeDetail(params) {  // 根据用户id获取用户信息
        return $axios({
            url: `${bizURL}/employee/employeeDetail?tokenId=${getToken()}`,
            method: "get",
            params: params
        });
    },
    getPhoto(params) {  // 查看学习照片
        return $axios({
            url: `${courseURL}/empStudy/getEmployeeStudyList?tokenId=${getToken()}`,
            method: "get",
            params: params
        });
    },
    updateInfo(params) { // 个人信息修改
        return $axios({
            url: `${bizURL}/employee/updateEmployeeInformation?tokenId=${getToken()}`,
            method: "post",
            data: params
        });
    },
    savePhoto(params) { // 实名认证
        return $axios({
            url: `${bizURL}/myAccount/uploadAccountPhoto?tokenId=${getToken()}`,
            method: "post",
            data: params
        });
    },
    registerList(params) {  // 获取报名管理信息
        return $axios({
            url: `${bizURL}/registration/getRegistrationEmployeeList?tokenId=${getToken()}`,
            method: "get",
            params: params
        });
    },
    deleteRegister(params) {  // 删除报名信息
        return $axios({
            url: `${bizURL}/registration/deleteRegistrationEmployee?tokenId=${getToken()}`,
            method: "post",
            data: params
        });
    },
    userSaveTrainingRecords(params) {  // 提交审核
        return $axios({
            url: `${courseURL}/course/userSaveTrainingRecords?tokenId=${getToken()}`,
            method: "post",
            data: params
        });
    },
    downloadTrainingProve(params) {  //  获取证书
        return $axios({
            url: `${courseURL}/trainingRecord/downloadTrainingProve?tokenId=${getToken()}`,
            method: "get",
            params: params
        });
    },
    saveTrainQuestionnaire(params) {  // 满意度问卷调查
        return $axios({
            url: `${courseURL}/videoPlay/saveTrainQuestionnaire?tokenId=${getToken()}`,
            method: "post",
            data: params
        });
    },
    checkEmployeeInformation(params) {  // 验证个人信息是否完整
        return $axios({
            url: `${bizURL}//employee/checkEmployeeInformation?tokenId=${getToken()}`,
            method: "get",
            params: params
        });
    },
}

export default portData;

